
# TL;DR

Lessons learned from "pdfer", "classroom slides", "authoring" and now math/ELA publishing into Q1.

![](2019-12-20-13-50-47.png)

1 publish
- multiple editions
- pdfs
  - teacher guide
  - all lesson guides
- standards
- zips
- audio
- qti

publish --> raw data 
